export default __webpack_public_path__ + "7d201f8ab29758060a506b8f5ca8802e.svg";